module.exports = __webpack_public_path__ + "static/img/login-to-kcc.91c7dce2.jpg";